import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-center" }, "Histogram Distance", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Images:", -1)
const _hoisted_3 = {
  ref: "imageContainer",
  class: "image-container mb-6"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Cross Distances:", -1)
const _hoisted_5 = { class: "distances-container mb-6" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", null, "Histogram Image 1/2 (r-channel):", -1)
const _hoisted_9 = { ref: "plotContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, null, 512),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageUrls, (url, index) => {
        return (_openBlock(), _createElementBlock("img", {
          class: "mini-image top",
          src: url,
          key: url,
          style: _normalizeStyle({ 'grid-column': index + 2 })
        }, null, 12, _hoisted_6))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageUrls, (url, index) => {
        return (_openBlock(), _createElementBlock("img", {
          class: "mini-image side",
          src: url,
          key: url,
          style: _normalizeStyle({ 'grid-row': index + 2 })
        }, null, 12, _hoisted_7))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.distances, (row, rowIndex) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: rowIndex }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (dist, colIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: rowIndex + '' + colIndex,
              style: _normalizeStyle({
            'grid-row': rowIndex + 2,
            'grid-column': colIndex + 2,
            '--lightness': 20 + ((80 - 20) * dist) / 2 + '%',
          }),
              class: "distance-positioner"
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.formatDistance(dist)), 1)
            ], 4))
          }), 128))
        ], 64))
      }), 128))
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, null, 512)
  ]))
}